<template>
  <div class="card mb-5 mb-xl-8">
    <div class="card-body p-1 shadow-sm border border-secondary">
      <slot name="content"></slot>
    </div>
  </div>
</template>
